import request from '@/utils/request'

let Pic_cottonApi = {

  /*采棉机图片管理列表*/
  list(data) {
    return request._post('/shop/plus.pic_cotton.Index/index', data);
},
/*添加采棉机图片管理*/
add(data) {
    return request._post('/shop/plus.pic_cotton.Index/add', data);
},
/*修改采棉机图片管理*/
edit(data) {
    return request._post('/shop/plus.pic_cotton.Index/edit', data);
},
/*删除采棉机图片管理*/
del(data) {
    return request._post('/shop/plus.pic_cotton.Index/del', data);
},
/*采棉机图片管理详情*/
detail(data) {
  return request._post('/shop/plus.pic_cotton.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pic_cotton.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pic_cotton.Setting/getSetting', data, errorback);
    },
}
export default Pic_cottonApi;



// WEBPACK FOOTER //
// ./src/api/pic_cotton.js